export default "__VITE_ASSET__CdXt61YI__"